import * as React from "react";
import {DynamicDialog, DynamicDialogProps, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {ReactNode} from "react";

import './ServerItemFieldPicker.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {faFrown} from "@fortawesome/free-solid-svg-icons/faFrown";
import {AccordionItem} from "shared/controls/Accordion/AccordionItem";

export class ServerItemFieldPicker extends DynamicDialog<FormulaFieldPickerProps, FormulaFieldPickerState> {
    static defaultProps: Partial<FormulaFieldPickerProps> = {};
    public Groups:ServerGroup[];
    constructor(props: FormulaFieldPickerProps) {
        super(props);
        this.state = {
            IsOpen: true,
            Filter:'',
        };

        this.GenerateGroups();
    }

    public GenerateGroups(){
        this.Groups=[];
        let fixedValuesGroup=new ServerGroup('Entry Information');
        this.Groups.push(fixedValuesGroup);


        let fieldGroup=new ServerGroup('Fields')
        this.Groups.push(fieldGroup);
        this.props.Fields.forEach(x=>fieldGroup.ServerGroupItem.push(new ServerGroupItem('field',x.Id+':'+ x.Label,x.Id)));


    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Select an item'
        };
    }

    SubRenderer(): ReactNode {
        
        return (
            <div className={'formulaFieldPicker'}>
                <div>
                    <div style={{width:'100%',position:'relative'}}>
                        <FontAwesomeIcon icon={faSearch} style={{position:'absolute',left:2,color:'#ccc',fontSize:20,marginTop:-10,top:'50%'}}/>
                        <input type={'text'} style={{width:'100%',paddingLeft:25}} placeholder={'Search a tag by label or id'} onChange={x=>this.Search(x.target.value)} value={this.state.Filter}/>
                    </div>

                    <div style={{marginTop:10}}>
                        {!this.Groups.some(x=>x.IsVisible)?<p style={{fontSize:18,display:'flex',alignItems:'center'}}><FontAwesomeIcon icon={faFrown}/> <span style={{marginLeft:5}}>There are no tags to show</span></p>:

                            this.Groups.map(x=>
                            x.IsVisible&&
                            <AccordionItem key={x.Label} Title={x.Label} IsOpen={x.IsOpen} IsOpenChanged={isOpen => {
                                x.IsOpen = isOpen;
                            }}>
                                {!x.ServerGroupItem.some(x => x.IsVisible) ?
                                    <p style={{margin: 0}}>There are no fields to add</p> :
                                    <ul style={{margin: -10}}>
                                        {x.ServerGroupItem.map(item =>
                                            item.IsVisible &&
                                            <li key={item.Value} className={'serverItemPicker'}
                                                onMouseUp={() => this.ValueSelected(item.Type, item.Value)}>{item.Label}</li>
                                        )}
                                    </ul>}
                            </AccordionItem>

                        )}
                    </div>
                </div>



            </div>
        )
    }


    private ValueSelected(type: string, value: number) {
        this.SendResult({Type:type,Value:value});
    }


    private Search(value: string) {
        value=value.toLowerCase();
        this.Groups.forEach(group=>{
            group.ServerGroupItem.forEach(item=>{
                item.IsVisible=item.Label.toLowerCase().indexOf(value)>=0||(item.Type=='field'&&item.Value==value)
                if(item.IsVisible==true) {
                    group.IsOpen = true;
                }
            });

            group.IsVisible=group.ServerGroupItem.some(x=>x.IsVisible);
        });

        this.setState({Filter:value});
        this.forceUpdate();


    }
}

class ServerGroup{
    public Label:string;
    public ServerGroupItem:ServerGroupItem[];
    public IsOpen:boolean;
    public IsVisible:boolean;

    constructor(label:string) {
        this.ServerGroupItem=[];
        this.IsOpen=true;
        this.Label=label;
        this.IsVisible=true;


    }

}

class ServerGroupItem{
    public Type:string;
    public Value:any;
    public Label:string;
    public IsVisible:boolean;

    public constructor(type:string,label:string,value:string) {
        this.Type=type;
        this.Value=value;
        this.Label=label;
        this.IsVisible=true;
    }

}

//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormulaFieldPickerProps extends DynamicDialogProps {
    Fields:FieldDTO[];

}

interface FormulaFieldPickerState extends DynamicDialogState {
    Filter:string;
}

//#endregion "My Region"